import './styles.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'flag-icons/css/flag-icons.min.css';
import Aurelia from 'aurelia';
import { RouterConfiguration } from '@aurelia/router';
import { I18nConfiguration } from '@aurelia/i18n';
import { App } from './app';
import { ConfirmDialog } from './components/confirm-dialog';
import { DocumentModal } from './components/document-modal';
import { NewFormDocumentModal } from './components/new-form-document-modal';
import { ImageEditorModal } from './components/image-editor-modal';
import { MoveFilesDialog } from './components/move-files-dialog';
import { DocumentView } from './components/document-view';
import { CamtAnalyticsModal } from './components/camt-analytics-modal';
import { PdfViewer } from './components/pdf-viewer';
import { FormTagSelect } from './components/form-tag-select';
import { TagInput } from './components/tag-input';
import { UserInput } from './components/user-input';
import { TagModal } from './components/tag-modal';
import { TagGroupModal } from './components/tag-group-modal';
import { RuleModal } from './components/rule-modal';
import { FormModal } from './components/form-modal';
import { FormViewModal } from './components/form-view-modal';
import { ShareModal } from './components/share-modal';
import { UploadConfigModal } from './components/upload-config-modal';
import { UploadConfigsPanel } from './components/upload-configs-panel';
import { BatchRuleDialog } from './components/batch-rule-dialog';
import { ViewHeader } from './components/view-header';
import { TagsList } from './views/tags-list';
import { RulesList } from './views/rules-list';
import { FormsList } from './views/forms-list';
import { FormViewsList } from './views/form-views-list';
import { FollowUpsView } from './views/follow-ups-view';
import { IncomingView } from './views/incoming-view';
import { HelpView } from './views/help-view';
import { BookmarksView } from './views/bookmarks-view';
import { DateValueConverter } from './converters/date';
import { DateTimeValueConverter } from './converters/date-time';
import { ImportProtocolsList } from './views/import-protocols-list';
import { ImportProtocolFilesView } from './views/import-protocol-files-view';

import enTranslation from './locales/en/translation.json';
import deTranslation from './locales/de/translation.json';
import esTranslation from './locales/es/translation.json';

// Apply persisted theme immediately to avoid flash
const savedTheme = localStorage.getItem('radish-theme') ?? 'light';
document.documentElement.setAttribute('data-theme', savedTheme);

// Strip trailing slash from URL so the router always sees clean paths (e.g. /followups/ → /followups)
const rawPath = window.location.pathname;
if (rawPath !== '/' && rawPath.endsWith('/')) {
  window.history.replaceState(null, '', rawPath.slice(0, -1) + window.location.search + window.location.hash);
}

Aurelia
  .register(
    RouterConfiguration.customize({
      useUrlFragmentHash: false,
      activeClass: 'active',
      basePath: '/',
    }),
    I18nConfiguration.customize(options => {
      options.initOptions = {
        lng: localStorage.getItem('radish-language') ?? 'en',
        fallbackLng: 'en',
        resources: {
          en: { translation: enTranslation },
          de: { translation: deTranslation },
          es: { translation: esTranslation },
        },
      };
    }),
    DateValueConverter,
    DateTimeValueConverter,
    ConfirmDialog,
    DocumentModal,
    NewFormDocumentModal,
    ImageEditorModal,
    MoveFilesDialog,
    DocumentView,
    CamtAnalyticsModal,
    PdfViewer,
    FormTagSelect,
    TagInput,
    UserInput,
    TagModal,
    TagGroupModal,
    RuleModal,
    FormModal,
    FormViewModal,
    ShareModal,
    UploadConfigModal,
    UploadConfigsPanel,
    BatchRuleDialog,
    ViewHeader,
    TagsList,
    RulesList,
    FormsList,
    FormViewsList,
    FollowUpsView,
    IncomingView,
    HelpView,
    BookmarksView,
    ImportProtocolsList,
    ImportProtocolFilesView,
  )
  .app(App)
  .start();
